export const fullscreenExpand = {
	className: 'icon-fullscreen-expand',
	viewBox: '0 0 223.26501 223.27201',
	paths: ['m 223.265,0 0,43.969 -14.768,0 0,-29.201 -29.195,0 0,-14.768 43.963,0 z m -14.768,208.497 -29.195,0 0,14.774 43.963,0 0,-43.968 -14.768,0 0,29.194 z m -193.729,-29.194 -14.768,0 0,43.969 43.963,0 0,-14.774 -29.195,0 0,-29.195 z M 0,43.969 l 14.768,0 0,-29.201 29.195,0 L 43.963,0 0,0 0,43.969 Z']
}
